import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultSettingData, getSettingById, updateSetting, createSetting } from '@/api/settings';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import { Action } from 'vuex-module-decorators';
import HelpText from '@/components/HelpText/index.vue';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.validateRequire = (rule, value, callback) => {
      if (value === '') {
        if (rule.field === 'imageURL') {
          this.$message({
            message: 'Upload cover image is required',
            type: 'error'
          });
        } else {
          this.$message({
            message: rule.field + ' is required',
            type: 'error'
          });
        }
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    };
    this.formData = Object.assign({}, defaultSettingData);
    this.loading = false;
    this.inputVisible = false;
    this.inputValue = '';
    this.rules = {
      bankInformation: [{
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      transactionPercent: [{
        min: 0,
        max: 100,
        type: 'number',
        message: 'Percentage should be less than 100',
        trigger: 'blur'
      }],
      bookingPercent: [{
        min: 0,
        max: 100,
        type: 'number',
        message: 'Percentage should be less than 100',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    if (this.isEdit) {
      // const id = this.$route.params && this.$route.params.id
      this.fetchData(1);
    } else {
      this.formData = Object.assign({}, defaultSettingData);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id = 1) {
    try {
      const data = await getSettingById(id);
      this.formData = data;
      // Just for test
      const title = this.formData.id.toString();
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  handleClose(tag) {
    this.formData.whatsappRecipients.splice(this.formData.whatsappRecipients.indexOf(tag), 1);
  }
  showInput() {
    this.inputVisible = true;
    this.$nextTick(() => {
      const tagRef = this.$refs.saveTagInput;
      tagRef.$refs.input.focus();
    });
  }
  handleInputConfirm() {
    const inputValue = this.inputValue;
    if (inputValue) {
      this.formData.whatsappRecipients.push(inputValue);
    }
    this.inputVisible = false;
    this.inputValue = '';
  }
  resetForm() {
    if (this.formData.id) {
      this.fetchData(this.formData.id);
    }
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        await updateSetting(this.formData.id, this.formData);
      } else {
        await createSetting(this.formData);
      }
      this.$notify({
        title: 'Success',
        message: 'Settings saved successfully',
        type: 'success',
        duration: 2000
      });
      this.loading = false;
      // router.push('/setting/info')
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'SettingDetail',
  components: {
    HelpText
  }
})], default_1);
export default default_1;